import { Fade, Slide } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";

import "./poles-advantages.scss";

const PolesAdvantages = () => {
  return (
    <section className="poles-advantages">
      <Fade direction="up" duration={800} triggerOnce>
        <IntroSectionBadge
          badgeText={"VANTAGGI PRINCIPALI"}
          title={"Perché Scegliere i Pali Rotoinfissi"}
          bgColor={"light"}
          icon="star"
        />
      </Fade>

      <div className="poles-advantages__cards-list">
        <Slide direction="left" duration={600} delay={0} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"volume-low"}
              title={"Vibrazioni Minime"}
              text={
                "Ideale vicino a edifici esistenti. L'installazione avviene senza produrre vibrazioni significative, permettendo interventi anche in contesti urbani sensibili."
              }
              type={"primary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>
        <Slide direction="right" duration={600} delay={10} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"recycle"}
              title={"Nessuna Produzione di Rifiuti"}
              text={
                "Non serve smaltire fanghi o detriti. Il processo non genera materiali di scarto, eliminando costi e tempi di smaltimento."
              }
              type={"secondary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>
        <Slide direction="left" duration={600} delay={200} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"euro"}
              title={"Costi Ridotti"}
              text={
                "Meno attrezzature e materiali di consumo necessari. La semplicità del sistema si traduce in significativi risparmi economici."
              }
              type={"secondary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>
        <Slide direction="right" duration={600} delay={300} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"screwdriver"}
              title={"Cantierizzazione Semplificata"}
              text={
                "Meno spazio occupato e tempi rapidi di esecuzione. Ideale per cantieri con limitazioni logistiche."
              }
              type={"primary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>

        <Slide direction="left" duration={500} delay={400} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"euro"}
              title={"Tecnologia Brevettata"}
              text={
                "Sistema applicabile a escavatori comuni con un semplice accessorio, garantendo versatilità e facilità d'uso."
              }
              type={"primary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>
        <Slide direction="right" duration={600} delay={500} triggerOnce>
          <CardDefault type={"grey"}>
            <IconDescription
              icon={"screwdriver"}
              title={"Diametro Personalizzabile"}
              text={
                "Da 15 cm a 40 cm, adattabile a ogni esigenza progettuale per massimizzare l'efficienza strutturale."
              }
              type={"secondary"}
              size={"medium"}
            />
          </CardDefault>
        </Slide>
      </div>
    </section>
  );
};

export default PolesAdvantages;
